import { BrowserRouter, Routes, Route } from "react-router-dom";
import Homepage from "./pages/Homepage";
// import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import LogsByDay from "./pages/LogsByDay";
import LogsSlow from "./pages/LogsSlow";
import RawData from "./pages/RawDatas";
import Report from "./pages/Report";
import RequireAuth from "./components/RequireAuth";
import Realtime from "./pages/RealTime";
import Devices from "./pages/DeviceManagement";
import DeviceCommands from "./pages/DeviceCommands";
import FirmwareCommands from "./pages/FirmwareCommands";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/"
          element={
            <RequireAuth>
              <Homepage />
            </RequireAuth>
          }
        >
          <Route path="history" element={<LogsByDay />} />
          <Route path="raw-data" element={<RawData />} />
          <Route path="report" element={<Report />} />
          <Route path="realtime" element={<Realtime />} />
          <Route path="device" element={<Devices />} />
          <Route path="device-command" element={<DeviceCommands />} />
          <Route path="firmware-commands" element={<FirmwareCommands />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
